import React, {Fragment, useState} from "react";
import "./index.scss";
import right_arrow from "../../../../assets/icons/car-lead-arrow-right.svg";
import left_arrow from "../../../../assets/icons/car-lead-left-arrow.svg";
import {useDispatch, useSelector} from "react-redux";
import {getMediaPath} from "../../../../app/functions";
import * as Actions from "../../../../redux/actions";
import * as Popups from "../../../../constants/popup-types";

const Catalog = (props) => {

    const text = useSelector(state => state.config.Translations);
    const vehicleAdDisplayTypes = useSelector(state => state.config.vehicleAdDisplayTypes);
    const deviceState = useSelector(state => state.state.deviceState);
    const vehicleAdsPage = useSelector(state => state.data.VehicleAdsPage);
    const dispatch = useDispatch();
    const [selected_tab, setSelectedTab] = useState(Object.keys(vehicleAdsPage.ads)[0]);


    function imageSizeClass(benefit){
        let type = parseInt(benefit.display_type_id);
        if(vehicleAdDisplayTypes[type] === "small_image"){
            return "small_image";
        }
        return "large_image";
    }

    const getBenefits = () =>{

        let res= [];

        vehicleAdsPage.ads[selected_tab].ads.forEach((benefit, index) =>{

            res.push(
                <div key={index} className={'link-wrapper '+ imageSizeClass(benefit) }>
                    <img src={displayImage(benefit)} alt="" className={"img-benefit "} />
                    <button className="benefit-btn" onClick={() => handleOpenBenefit(benefit)}>{benefit.btnText}</button>
                </div>
            )
        });


        return res;

    };

    const handleOpenBenefit = (benefit) => {
        let adId = benefit.id;

        dispatch(Actions.addPopup({
            type: Popups.CAR_LEAD_FORM_POPUP,
            screenHeight : window.innerHeight,
            data: adId,
            isExpert:false,
            title: text["car_lead_popup_ad_title"],
            titleBold: text["car_lead_popup_ad_title_bold"],
        }));
    }

    //there are different images displayed between the tablet
    // and mobile to the desktop and desktop-large
    // this displays the correct one according to screen size
    function displayImage(benefit){
        if(deviceState === "mobile" || deviceState === "tablet"){
            return getMediaPath(benefit.mobileImagePath);
        }
        return getMediaPath(benefit.imagePath);
    }



    return(
        <div className='catalog'>

            <Fragment>
                <h3 className='catalog-title'>{text["car_lead_catalog_page_title"]}</h3>
                <div className='arrows-wrapper'>
                    <img src={right_arrow} alt=''/>
                    <img src={left_arrow} alt=''/>
                </div>
                <div className='navbar'>
                    <div className={'tab ' + (selected_tab === Object.keys(vehicleAdsPage.ads)[0] ? 'selected' : '')} onClick={()=> setSelectedTab(Object.keys(vehicleAdsPage.ads)[0])}>
                        <span>{vehicleAdsPage.ads[Object.keys(vehicleAdsPage.ads)[0]].title_prefix}</span>
                        <span>{vehicleAdsPage.ads[Object.keys(vehicleAdsPage.ads)[0]].title}</span>
                    </div>
                    <div className={'tab ' + (selected_tab === Object.keys(vehicleAdsPage.ads)[1] ? 'selected' : '')} onClick={()=> setSelectedTab(Object.keys(vehicleAdsPage.ads)[1])}>
                        <span>{vehicleAdsPage.ads[Object.keys(vehicleAdsPage.ads)[1]].title_prefix}</span>
                        <span>{vehicleAdsPage.ads[Object.keys(vehicleAdsPage.ads)[1]].title}</span>
                    </div>
                </div>
                <div className={'links-container '}>
                    {getBenefits()}
                </div>
            </Fragment>

        </div>
    );
}

export default Catalog;